<template>
	<div>
		<b-carousel class="visible-xs-block" id="carousel-1" v-model="slide" :interval="4000" controls indicators
			background="#ababab" img-width="1024" img-height="550" style="text-shadow: 1px 1px 2px #333;"
			@sliding-start="onSlideStart" @sliding-end="onSlideEnd">
			<b-carousel-slide v-for="(item,index) in h5List" :key="index">
				<template #img>
					<img class="d-block img-fluid w-100 banner-img" :src="item.picLinkUrl" alt="image slot">
				</template>
			</b-carousel-slide>
		</b-carousel>
		<b-carousel class="hidden-xs" id="carousel-1" v-model="slide" :interval="4000" controls indicators
			background="#ababab" img-width="1024" img-height="550" style="text-shadow: 1px 1px 2px #333;"
			@sliding-start="onSlideStart" @sliding-end="onSlideEnd">
			<b-carousel-slide v-for="(item,index) in webList" :key="index">
				<template #img>
					<img class="d-block img-fluid w-100 banner-img" :src="item.picLinkUrl" alt="image slot">
				</template>
			</b-carousel-slide>
		</b-carousel>
		<b-container class="bv-example-row">
			<div class="notic-bar">
				<img @click="toInform" src="../assets/imgs/notice.png" class="notice-img" />
				<el-carousel indicator-position="none" class="lunbo" height="35" direction="vertical">
					<el-carousel-item style="cursor: pointer;" @click.native="toDetails(item)"
						v-for="(item, index) in list" :key="index">
						<div>{{item.noticeTitle}}</div>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="between_layout">
				<div class="study-area">学习平台</div>
				<router-link to="/purchase">
					<el-button class="visible-xs-block" type="primary" size="small" round
						icon="el-icon-notebook-1">苏学码购买</el-button>
				</router-link>
			</div>
			<div class="hidden-xs" style="display: flex;flex-wrap: wrap;width: 100%;justify-content: space-between;">
				<div style="margin-bottom: 20px;width: 32%;" v-for="(item, index) in dataList" :key="index">
					<div @click="toDetail(item)" class="lesson-item">
						<img class="lesson-img" :src="item.picLinkUrl" />
						<div
							style="background-color: #fff;border: 1px solid #ddd;border-radius: 0 0 4px 4px;padding: 15px;">
							{{item.title}}
						</div>
					</div>
				</div>
				<div style="width: 32%;"></div>
				<div style="width: 32%;"></div>
			</div>
			<b-row class="visible-xs-block" v-for="(item, index) in Math.ceil(dataList.length / 3)" :key="index">
				<b-col v-for="(item1, index1) in dataList.slice(index * 3,item * 3)" :key="index1" sm>
					<div @click="toDetail(item1)" class="lesson-item" style="margin-bottom: 30px;">
						<img class="lesson-img" :src="item1.picLinkUrl" />
						<div
							style="background-color: #fff;border: 1px solid #ddd;border-radius: 0 0 4px 4px;padding: 15px;">
							{{item1.title}}
						</div>
					</div>
				</b-col>
			</b-row>
			<b-modal ref="my-modal" title="提示">
				<p class="my-4">温馨提示：输入苏学码点击确定即可参加培训</p>
				<b-form-input v-model="code" placeholder="请输入苏学码"></b-form-input>
				<p class="my-4">没有苏学码？
					<router-link to="/purchase">
						<span style="color: #409EFF;cursor: pointer;">点击购买</span>
					</router-link>
				</p>
				<template v-slot:modal-footer="{ ok, cancel, hide }">
					<b-button variant="success" @click="submit()">
						确定
					</b-button>
					<b-button variant="danger" @click="cancel()">
						取消
					</b-button>
				</template>
			</b-modal>
		</b-container>
	</div>
</template>

<script>
	import {
		lessonList,
		checkUserHasBind,
		bindCode,
		noticeList,
		viewPager
	} from "@/api/lesson";
	import {
		checkUserIsPerfect
	} from "@/api/userCenter";
	export default {
		data() {
			return {
				platformId: "",
				platformName: '',
				code: "",
				slide: 0,
				sliding: null,
				dataList: [],
				list: [],
				webList: [],
				h5List: []
			}
		},
		created() {
			// checkUserIsPerfect()
			lessonList().then(res => {
				this.dataList = res.rows
			})
			viewPager("web").then(res => {
				this.webList = res.data
			})
			viewPager("H5").then(res => {
				this.h5List = res.data
			})
			noticeList({
				pageSize: 10,
				pageNum: 1,
				noticeType: 2
			}).then(res => {
				this.list = res.rows
			})
		},
		methods: {
			onSlideStart(slide) {
				this.sliding = true
			},
			onSlideEnd(slide) {
				this.sliding = false
			},
			//跳转课程详情
			toDetail(item) {
				checkUserIsPerfect().then(user => {
					if (user.data) {
						checkUserHasBind(item.baseId).then(res => {
							if (res.data) {
								this.$router.push({
									path: "/learn",
									query: {
										baseId: item.baseId
									}
								})
							} else {
								this.platformId = item.baseId
								this.platformName = item.title
								this.code = ""
								this.$refs['my-modal'].show()
							}
						})
					} else {
						this.$message.error('请先完善用户信息！');
						this.$router.push({
							path: "/profile?type=7"
						})
					}
				})

			},
			toInform() {
				this.$router.push({
					path: "/collecting"
				})
			},
			//跳转详情
			toDetails(item) {
				this.$router.push({
					path: "/collecting/details",
					query: {
						baseId: item.noticeId,
					}
				});
			},
			//提交苏学码
			submit() {
				if (this.code) {
					bindCode(this.platformId, this.code).then(res => {
						if (res.code == 200) {
							this.$router.push({
								path: "/learn",
								query: {
									baseId: this.platformId,
									name: this.platformName
								}
							})
						} else {
							this.$message.error(res.msg);
						}
					})
				} else {
					this.$message.error('请输入苏学码！');
				}
			}
		}
	}
</script>

<style scoped>
	.banner-img {
		height: 550px;
		width: 100%;
	}

	.lesson-img {
		width: 100%;
		border-radius: 4px 4px 0 0;
		height: 200px;
	}

	.lesson-item {
		transition-duration: 300ms;
		border-radius: 4px 4px 0 0;
	}

	.lesson-item:hover {
		cursor: pointer;
		/* transform属性 */
		transform: translate(0, -10px);
		transition-duration: 300ms;
		box-shadow: 0 0 20px 2px #918f8f;
		/*盒子阴影*/
	}

	.study-area {
		font-size: 26px;
		font-weight: 600;
		padding: 15px 0;
	}

	@media screen and (max-width: 997px) {
		.study-area {
			font-size: 20px;
			font-weight: 600;
			padding: 15px 0;
		}

		.banner-img {
			height: 250px;
			width: 100%;
		}
	}

	.notic-bar {
		display: flex;
		align-items: center;
		background: #fff;
		margin-top: 20px;
		border-radius: 50px;
		padding: 10px 15px;
		box-shadow: 0 0 10px 1px rgba(145, 143, 143, 0.3);
	}

	.notice-img {
		width: 25px;
		height: 25px;
	}

	.lunbo {
		padding: 0 8px 0 0;
		box-sizing: border-box;
		height: 35px;
		line-height: 35px;
		text-overflow: ellipsis;
		word-break: keep-all;
		white-space: nowrap;
		overflow: hidden;
		flex: 1;
		margin-left: 15px;
	}
</style>